import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CifcViewComponent } from './components/cifc/cifc-view/cifc-view.component';
import { CstViewComponent } from './components/cst/cst-view/cst-view.component';
import { CustomerViewComponent } from './components/customer/customer-view/customer-view.component';
import { OverviewSidenavComponent } from './components/shared/overview-sidenav/overview-sidenav.component';
import { OverviewProgressComponent } from './components/shared/overview-progress/overview-progress.component';
import { SlideshowComponent } from './components/shared/slideshow/slideshow.component';
import { FormComponent } from './components/shared/questions/form/form.component';
import { MultipleSelectionComponent } from './components/shared/questions/multiple-selection/multiple-selection.component';
import { SingleSelectionComponent } from './components/shared/questions/single-selection/single-selection.component';
import { MatrixComponent } from './components/shared/questions/matrix/matrix.component';
import { MultilineTextComponent } from './components/shared/questions/multiline-text/multiline-text.component';
import { BannerComponent } from './components/shared/banner/banner.component';
import { ReviewBannerComponent } from './components/customer/components/review-banner/review-banner.component';
import { CustomerQuestionnaireRoutingModule } from './customer-questionnaire-routing.module';
import { ComponentsModule } from '../../../common-modules/components/components.module';
import { MatButtonModule } from '@angular/material/button';
import { QuestionnaireComponent } from './components/customer/components/questionnaire/questionnaire.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MdrDashboardsModule } from '../mdr-dashboards/mdr-dashboards.module';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { QuestionFooterComponent } from './components/shared/questions/question-footer/question-footer.component';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ResumeQuestionnaireComponent } from './components/customer/components/resume-questionnaire/resume-questionnaire.component';
import { FinishedQuestionnaireComponent } from './components/customer/components/finished-questionnaire/finished-questionnaire.component';
import { StartQuestionnaireComponent } from './components/customer/components/start-questionnaire/start-questionnaire.component';
import { MatChipsModule } from '@angular/material/chips';
import { QuestionTemplateDirective } from './components/shared/directives/question-template.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { AuthModule } from '../auth/auth.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SectionCreateComponent } from './components/cst/components/section-create/section-create.component';
import { QuestionHeaderComponent } from './components/shared/questions/question-header/question-header.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NoQuestionsCreatedComponent } from './components/cst/components/no-questions-created/no-questions-created.component';
import { DescriptionDialogComponent } from './components/shared/description-dialog/description-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CheckSubmitComponent } from './components/customer/components/check-submit/check-submit.component';

@NgModule({
    declarations: [
        CifcViewComponent,
        CstViewComponent,
        CustomerViewComponent,
        OverviewSidenavComponent,
        OverviewProgressComponent,
        SlideshowComponent,
        FormComponent,
        MultipleSelectionComponent,
        SingleSelectionComponent,
        MatrixComponent,
        MultilineTextComponent,
        BannerComponent,
        ReviewBannerComponent,
        QuestionnaireComponent,
        QuestionFooterComponent,
        ResumeQuestionnaireComponent,
        FinishedQuestionnaireComponent,
        StartQuestionnaireComponent,
        QuestionTemplateDirective,
        FormComponent,
        MultipleSelectionComponent,
        SingleSelectionComponent,
        MatrixComponent,
        MultilineTextComponent,
        SectionCreateComponent,
        QuestionHeaderComponent,
        NoQuestionsCreatedComponent,
        DescriptionDialogComponent,
        CheckSubmitComponent,
        CheckSubmitComponent,
    ],
    exports: [BannerComponent],
    imports: [
        CommonModule,
        CustomerQuestionnaireRoutingModule,
        ComponentsModule,
        MatButtonModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MdrDashboardsModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatListModule,
        MatRadioModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatTooltipModule,
        MatSortModule,
        MatMenuModule,
        AuthModule,
        FormsModule,
        DragDropModule,
        MatDialogModule,
        ReactiveFormsModule,
    ],
})
export class CustomerQuestionnaireModule {}
